/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";

/**
 * set document title when router change
 * @param {String} title title name
 */
export function setTitle(title) {
  document.title = title;
  var iframe = document.createElement('iframe');
  iframe.style.visibility = 'hidden';

  var iframeCallback = function iframeCallback() {
    setTimeout(function () {
      iframe.removeEventListener('load', iframeCallback);
      document.body.removeChild(iframe);
    }, 0);
  };

  iframe.addEventListener('load', iframeCallback);
  document.body.appendChild(iframe);
}
/**
 * cache return for function, ensure that the function is executed only once
 * @param {Function} func
 */

export function onceWrapper(func) {
  var isExecuted = false;
  var promiseObj = null;
  return function () {
    if (isExecuted) return promiseObj;
    isExecuted = true;
    promiseObj = func.apply(void 0, arguments);
    return promiseObj;
  };
}
/**
 * 时间戳格式化.
 * @param  {number} time 时间戳 .
 * @param  {string} formatStr 格式 .
 * @param  {boolean} ms 时间戳是否是秒为单位, 10位true, 13位false .
 * @return {string} 格式化后的字符串.
 */

export function format(time, formatStr, ms) {
  var t = new Date(ms ? time * 1000 : time);

  var tf = function addZero(i) {
    return (i < 10 ? '0' : '') + i;
  };

  return formatStr.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
    switch (a) {
      case 'yyyy':
        return tf(t.getFullYear());

      case 'MM':
        return tf(t.getMonth() + 1);

      case 'mm':
        return tf(t.getMinutes());

      case 'dd':
        return tf(t.getDate());

      case 'HH':
        return tf(t.getHours());

      case 'ss':
        return tf(t.getSeconds());

      default:
        return '';
    }
  });
}